<template>
    <table class="table" :style="`max-height: calc(100vh - ${rectTop + 30}px);`" ref="table">
      <div>
        <thead>
          <tr>
            <th
              v-if="hasCheckbox"
              class="th__checkbox"
            >
              <AppCheckbox
                :checked="allItemsActive"
                @toggle-check="toggleActiveAll"
              />
            </th>

            <th
              v-for="(item, index) in tableHeadAddRows ? headers[0] : headers"
              :key="index"
              @click="item.isSortable && sort(item.dispatchName, item.sortName, index)"
              :style="item.isSortable ? 'cursor:pointer': null"
              :class="{ numbered: numbered && index === 0, 'th--center': item.mod === 'colspan' }"
              :width="numbered ? null : 100 / headers.length + '%'"
              :colspan="item.isColspan ? item.colspan : ''"
              :rowspan="item.isRowspan ? item.rowspan : ''"
            >
              {{ item.mod === 'innerHTML' ? '' : item.title }}

              <span
                v-if="item.mod === 'innerHTML'"
                class="th--inner-html"
                v-html="item.title"
              />

              <span
                v-if="item.isSortable"
                class="drop-icon table__drop-icon"
              >
                <svg
                  class="dropdown-icon"
                  :style="sortIndex[index] ? 'transform: rotate(180deg)' : null"
                  viewBox="0 0 12 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2"/>
                </svg>
              </span>
            </th>
            <th v-if="isMenuControlsActive"></th>
          </tr>
          <tr v-for="i in tableHeadAddRows" :key="i">
            <th
              v-for="(item, index) in headers[i]"
              :key="index"
            >
              {{ item.title }}
            </th>
          </tr>
        </thead>

        <Preloader
          v-if="loading"
          background="#F3F5FF"
          style="position:fixed; left: 50%; margin: 10px 0; transform: translateX(-50%)"
        />

        <tbody v-if="isSpecial && !loading">
          <!--этот компонент ждёт в values объекты { data: 'value', mod: '' }
          для того чтобы к каждой ячейки можно было передавать модификатор для уникальной стилизации-->
          <AppTableSpecialElem
            v-for="(item, i) in data"
            :key="item.id"
            :itemId="item.id"
            :values="item.values"
            :count="i + 1"
            :has-checkbox="hasCheckbox"
            :has-count="hasCount"
            :is-active="item.isActive"
            :is-deactive="item.deactive"
            :is-warning="item.warning"
            :is-menu-controls-active="isMenuControlsActive"
            :menu-controls="menuControls"
            :isControlsActive="item.isControlsActive"
            @edit-this-item="editItem(item.id)"
            @remove-this-item="removeItem(item.id)"
            @show-this-item="showItem(item.id)"
            @toggle-active="toggleActiveItem(item.id)"
            @toggle-controls="itemToggleControls(item.id)"
            @onSelect="onSelect"
          />
        </tbody>

        <tbody v-else-if="!isSpecial && !loading">
          <AppTableElem
            v-for="item in data"
            :key="item.id"
            :itemId="item.id"
            :values="item.values"
            :has-checkbox="hasCheckbox"
            :is-active="item.isActive"
            :is-deactive="item.deactive"
            :is-warning="item.warning"
            :is-menu-controls-active="isMenuControlsActive"
            :menu-controls="menuControls"
            :isControlsActive="item.isControlsActive"
            @edit-this-item="editItem(item.id)"
            @remove-this-item="removeItem(item.id)"
            @show-this-item="showItem(item.id)"
            @toggle-active="toggleActiveItem(item.id)"
            @toggle-controls="itemToggleControls(item.id)"
          />
        </tbody>
      </div>
    </table>
</template>

<script>
import AppTableElem from '@/components/page/table/AppTableElem.vue'
import AppTableSpecialElem from '@/components/page/table/AppTableSpecialElem'
import AppCheckbox from '@/components/page/input/AppCheckbox'
import Preloader from '@/components/page/Preloader'
import SearchForm from '@/components/page/input/SearchForm'
import AppButton from '@/components/page/button/AppButton'

export default {
  name: 'app-table',
  components: {
    AppCheckbox,
    AppTableSpecialElem,
    AppTableElem,
    Preloader,
    // eslint-disable-next-line vue/no-unused-components
    SearchForm,
    // eslint-disable-next-line vue/no-unused-components
    AppButton
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    hasCheckbox: {
      type: Boolean,
      default: false
    },
    hasCount: {
      type: Boolean,
      default: false
    },
    allItemsActive: {
      type: Boolean,
      default: false
    },
    isMenuControlsActive: {
      type: Boolean,
      default: false
    },
    menuControls: {
      type: Object,
      default: () => ({
        add: false,
        update: false,
        remove: false
      })
    },
    loading: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Array,
      default: () => []
    },
    numbered: {
      type: Boolean,
      default: false
    },
    sortActionName: {
      type: String,
      required: false,
      default: ''
    },
    tableHeadAddRows: {
      type: Number,
      required: false,
      default: 0
    },
    comment: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.rectTop = this.$refs.table.getBoundingClientRect().top
  },
  data () {
    return {
      sortIndex: new Array(this.headers.length).fill(false),
      popups: new Array(this.filters.length).fill(false),
      selectedPopupFilters: new Array(this.filters.length).fill([]),
      appliedFilters: new Array(this.filters.length).fill([]),
      rectTop: 0
    }
  },
  computed: {
    isPopupOpen () {
      return this.popups.some(p => p)
    },
    centerOfScrollTable () {
      return (window.innerWidth - (360 + 175)) / 2 - 40
    }
  },
  methods: {
    toggleActiveAll () {
      this.$emit('toggle-active-all')
    },
    toggleActiveItem (id) {
      this.$emit('toggle-active-item', id)
    },
    editItem (id) {
      this.$emit('edit-this-item', id)
    },
    removeItem (id) {
      this.$emit('remove-this-item', id)
    },
    itemToggleControls (id) {
      this.$emit('toggle-controls', id)
    },
    itemToggleChildren (id) {
      this.$emit('toggle-children', id)
    },
    showItem (itemId) {
      this.$emit('show-this-item', itemId)
    },
    onSelect (data) {
      this.$emit('onSelect', data)
    },
    sort (dispatchName, sortName, i) {
      this.$set(this.sortIndex, i, !this.sortIndex[i])

      const sortOptions = {
        name: sortName,
        descending: !this.sortIndex[i]
      }

      if (dispatchName && sortName) {
        return this.$store.dispatch(dispatchName, sortOptions)
      }

      this.$emit('sort-item', sortOptions)
    },
    openPopup (i) {
      this.$set(this.selectedPopupFilters, i, this.appliedFilters[i])
      if (this.popups[i]) {
        this.$set(this.popups, i, false)
      } else {
        this.popups = this.popups.map(p => false)
        this.$set(this.popups, i, true)
      }
    },
    addFilter (filter, popupIndex) {
      const popupFilters = [...this.selectedPopupFilters[popupIndex], filter]
      this.$set(this.selectedPopupFilters, popupIndex, popupFilters)
    },
    deleteFilter (selectedIndex, popupIndex) {
      const selected = this.selectedPopupFilters[popupIndex]
      selected.splice(selectedIndex, 1)
      this.$set(this.selectedPopupFilters, popupIndex, selected)
    },
    applieFilters (popupIndex) {
      const applied = JSON.stringify(this.selectedPopupFilters[popupIndex])
      this.$set(this.appliedFilters, popupIndex, JSON.parse(applied))
    },
    clearFilters (popupIndex) {
      this.$set(this.appliedFilters, popupIndex, [])
      this.$set(this.selectedPopupFilters, popupIndex, [])
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/system/_vars";
@import "../../../assets/css/system/_mixins";

@import "./_table";

.filter {
  display: flex;
  align-items: center;
  padding: 0 14px;
  height: 50px;
  width: calc(100% + 10px);
  border-radius: 7px 7px 0 0;

  .filter__item {
    display: flex;
    align-items: center;
    color: #0e619f;
    margin-right: 15px;
    cursor: pointer;
    position: relative;

    .item__selected {
      margin-left: 7px;

      .item__selected-count {
        color: white;
        width: 19px;
        height: 19px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f66d59;
        border-radius: 50%;
      }
    }

    .item__popup {
      display: flex;
      flex-direction: column;
      width: 377px;
      height: 443px;
      position: absolute;
      top: 140%;
      left: calc(100% - 26px);
      z-index: 1000;
      background: white;
      border-radius: 3px;
      box-shadow: 0px 7px 11px rgba(23, 63, 125, 0.25);
      cursor: auto;

      &:before {
        content: "";
        display: block;
        position: absolute;
        top: -6px;
        left: 15px;
        margin: 0 auto;
        width: 10px;
        height: 10px;
        background: #f3f5ff;
        border: 1px solid $border_color;
        border-bottom: none;
        border-right: none;
        transform: rotate(45deg);
      }

      .popup__filters {
        background: #f3f5ff;
        height: 50%;
        padding: 10px;
      }

      .popup__buttons {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 10px;
        margin-top: auto;
      }

      .popup__scroll {
        display: flex;
        flex-direction: column;
        height: 128px;
        width: 100%;
        // margin: 10px;
        color: #697178;
        overflow: auto;

        svg {
          cursor: pointer;
        }

        &::-webkit-scrollbar {
          width: 7px;
          height: 10px;
        }

        &::-webkit-scrollbar-track {
          background-color: $color_third;
        }

        &::-webkit-scrollbar-thumb {
          background-color: $color_second-light;
          min-width: 300px;
        }

        .popup__scroll-item:not(:last-of-type) {
          margin-bottom: 15px;
        }
      }
    }

    .active__icon {
      transform: rotate(180deg);
    }
  }
}

.preloader__parent {
  position: relative;
}

table {
  .th {
    &__checkbox {
      border-right:1px solid #C4C4C4;
      padding: 0 10px;
    }
  }

  th:not(.th__checkbox):not(.numbered) {
    width: 100vw !important;
  }
}
</style>
